
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Consultant
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


                    <!-- feature box begin -->
                    <div class="col-md-12 feature-box mb40 sq-item wow">
                      <div class="feature-box style-2 left">
                        <i class="fa fa-tasks" aria-hidden="true"></i>
                        <div class="text para_cls">
                          <h3>	Project Background:</h3>
                          <p> The National Council for Vocational Education and Training (NCVET) is an autonomous regulatory body under Ministry of Skill Development and Entrepreneurship. It is a unified overarching umbrella regulator establishing regulations and standards to ensure quality in the TVET in India. Regulation of Awarding body, Assessment Agencies, other stake holders in the skill ecosystem and anchoring NSQFare the key focus areas of NCVET. </p>
                        
                        </div>
                      </div>
                    </div>
                    <!-- feature box close -->

            <!-- feature box begin -->
            <div class="col-md-12 feature-box mb40 sq-item wow">
              <div class="feature-box style-2 left">
                <i class="fa fa-gavel" aria-hidden="true"></i>
                <div class="text para_cls">
                  <h3>	Key responsibilities:</h3>
                  <p> <b> Consultant shall be responsible for the following activities: </b> </p>
                    <p> <span class="step_no">1</span> Design and support various activates being undertaken at NCVET.</p>
                    <p> <span class="step_no">2</span>Assist in formulation of guidelines and convert them into structured requirements document.</p>
                    <p> <span class="step_no">3</span>Process implementation of guidelines and policies.</p>
                    <p> <span class="step_no">4</span> Handling and processing of various proposals and RFPs knowledge of standard government RFPs will be added.</p>
                    <p> <span class="step_no">5</span>Coordination with stake holders in skill ecosystem.</p>
                    <p> <span class="step_no">6</span>System Integration Experience, including interface design and familiarity with various architectures. Comfortable with Open Source Products &amp; Systems and various technology architectures &amp; application landscape.</p>
                    <p> <span class="step_no">7</span> Assist in Preparation of periodic analytical reports &amp; Dashboards. Basic Knowledge of AI/ML will be added advantage.
                    </p>
                    <p> <span class="step_no">8</span>Knowledge of new age technologies and usage of these technologies in Edutech and skilling domain.</p>
                    <p> <span class="step_no">9</span> Any other work as per NCVET requirement. </p>
                </div>
              </div>
            </div>
            <!-- feature box close -->

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualification: </h3>
              <p> <span class="step_no">1</span>BE/B.Tech followed by MBA/M.Tech from reputed Institute/ University. </p>




            </div>
          </div>
        </div>
        <!-- feature box close -->




  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Experience:</h3>
        <p> <span class="step_no">1</span>Minimum seven years of professional experience, 5+ years’ experience in a top-tier consulting firm/multilateral institution </p>
		<p> <span class="step_no">2</span> At least one year in Edu Tech/skill related job. </p>
		<p> <span class="step_no">3</span> Work experience in Policy formulation, planning, strategy, processes etc. with the Govt. or reputed development organisations or multilateral agencies. </p>
		<p> <span class="step_no">4</span> First-hand experience or Understanding of developing and executing regulatory mechanism. </p>
        <p> <span class="step_no">5</span> Experience in report writing, working on frameworks and policy  documents, research proposals publishing articles. </p>
        <p> <span class="step_no">6</span> Experience or understanding of secure web portal development &amp; change management process. </p>


       </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-user"></i>
      <div class="text para_cls">
        <h3>Age Limit:</h3>
        <p> 35 years</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 50,000/- to 2,00,000/- per month /-consolidated pay from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.</p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 15th November 2021 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Skills and Competencies:</h3>
        <p><span class="step_no">1</span>Proficient in handling computer and office related tools.</p>
        <p><span class="step_no">2</span>Strong analytical and documentation skills.</p>
        <p><span class="step_no">3</span>Should have experience in implementing projects in multi stakeholder environment.</p>
		<p><span class="step_no">4</span>Project Management &amp; Vendor Management.</p>
		<p><span class="step_no">5</span>Understanding of IT systems &amp; technologies related to development of web page, MIS and mobile applications.</p>
		<p><span class="step_no">6</span> Understanding of Information Security &amp; Data privacy rules is desirable. </p>
		<p><span class="step_no">7</span>Should be able to operate in unstructured environment with minimal support.</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->


    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Nature of engagement:</h3>
        <p><span class="step_no">1</span>Annual contract with performance based extension of contract as per project requirement.</p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>Delhi</p>





      </div>
    </div>
  </div>
  <!-- feature box close -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
